import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const CancelModal = ({ isOpen, toggle, onConfirmCancel }) => (
    <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="modal-dialog-v-centered modal-horizontally-centered"
    >
        <ModalHeader>Leaving Edit Mode</ModalHeader>
        <ModalBody>
            <p>Are you sure that you want to leave Edit Mode?</p>
            <p>Your changes will be cancelled.</p>
        </ModalBody>
        <ModalFooter>
            <button className="btn btn-cancel col" onClick={onConfirmCancel}>
                Leave Edit Mode
            </button>
            <button className="btn btn-primary col" onClick={toggle}>
                Stay in Edit Mode
            </button>
        </ModalFooter>
    </Modal>
)

export default CancelModal
